// Import Vue
import Vue from 'vue'
import VueRouter from 'vue-router'
import { createPinia, PiniaVuePlugin } from 'pinia'

import useTouristStore from '@/tourist/tourist-store.js'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import {TSTORE_TYPE_CRUISE} from '@/tourist/tourist-store.js'
import {LOCALSTOR_TOURIST_KEY, LOCALSTOR_BC, clean_cruise_localStorage} from '@/localStor.js'


import CruiseRoot from '@/Root.vue'
import SearchPage from '@/SearchPage.vue'

import CruiseOverviewPage from '@/CruiseOverviewPage.vue'
import CruiseFillPage from '@/CruiseFillPage.vue'

import ShipPage from '@/ShipPage.vue'
import BookOkPage from '@/BookOkPage.vue'
import CruiseBookPage from '@/CruiseBookPage.vue'
import UonPage from '@/UonPage.vue'

import ByHandPage from '@/ByHandPage.vue'
import AdminServerTmPage from '@/AdminServerTmPage.vue' // служебный


import {testappUse, testappRoutes  } from 'TESTAPP/testapp.js'


function start_eto_cruise( el ) {

    Vue.use(PiniaVuePlugin)
    const pinia = createPinia()
    Vue.use(VueRouter)

    const route_ctype = (query)=> {
        let t = query.type
        if (!["river", "sea"].includes( t )) {
            t = 'river'
        }
        return t
    }

    let routes=[
        {
            path: '/',
            name: 'Search',
            component: SearchPage,
            props: {ctype: 'river'}
        },
        {
            path: '/sea',
            name: 'SearchSea',
            component: SearchPage,
            props: {ctype: 'sea'}
        },
        {
            path: '/list',
            name: 'CruiseList',
            component: SearchPage,
            props: route => ({ ctype: route_ctype(route.query), pokazat: true,  })
        },
        {
            path: '/byhand',
            name: 'ByHand',
            component: ByHandPage,
        },

        {
            path: '/cruise',
            name: 'Cruise',
            component: CruiseOverviewPage,
        },

        {
            path: '/fill',
            name: 'CruiseFill',
            component: CruiseFillPage,
        },


        {
            path: '/book',
            name: 'CruiseBook',
            component: CruiseBookPage,
        },

        {
            path: '/book-ok',
            name: 'BookOk',
            component: BookOkPage,
        },
        {
            path: '/ship',
            name: 'Ship',
            component: ShipPage,
        },
        {
            path: '/admin-server-tm',
            name: 'AdminServerTm',
            component: AdminServerTmPage,
        },
        {
            path: '/uon',
            name: 'Uon',
            component: UonPage,
            meta: {
                skipUplinks: true
            }
        },
    ];
    if (testappUse) {
        routes = routes.concat( testappRoutes() )
    }

    // Configure router
    const router = new VueRouter({
        routes,
        linkActiveClass: 'active',
        mode: 'hash'
    });
    router.beforeEach((to, from, next) => {
        if (["Search", "SearchSea"].includes(to.name) ) {
            let type = "SearchSea" === to.name ? 'sea' : 'river'
            next({
                path: '/list',
                query: {
                    type
                }
            })
        } else {
            next()
        }
    })


    clean_cruise_localStorage()


    const cruise = new Vue({
        render: h => h(CruiseRoot),
        router,
        pinia,
    })

    const cstore=useCruiseStore()
    const tstore=useTouristStore()
    tstore.init(TSTORE_TYPE_CRUISE)
    tstore.setLSkey(  LOCALSTOR_TOURIST_KEY )
    const bookCabins = useCabinsStore()
    bookCabins.saveLocalStorage( LOCALSTOR_BC )

    cruise.$mount(el)
}


Object.assign( window, { 
    start_eto_cruise,
} )


if (testappUse) {
    // debug
    window.cstore = cstore
    window.bookCabins = bookCabins
    window.tstore = tstore
    start_eto_cruise( '#cruise' )
}
